module.exports = __webpack_public_path__ + "b01557494a691ae6a274305bc562d14a.jpg";